import * as classNames from "classnames";
import * as React from "react";
import * as myClasses from "../";

import { HTMLDivProps, Position, Text, Tooltip } from "@blueprintjs/core";

import { MPDButton } from "src/mpd-library";

import "./styles.css";

interface IMoreInfoProps extends HTMLDivProps {
  className?: string;
  text?: string;
  onClick(event: any): void;
}

export const MoreInfo: React.SFC<IMoreInfoProps> = props => {
  const { className, onClick, text } = props;

  const classes = classNames(myClasses.MORE_INFO, className);

  return (
    <div className={classes}>
      <Tooltip
        portalClassName="more-info-tooltip"
        className="more-info-container"
        content={<Text> {text ? text : "More Info"} </Text>}
        position={Position.RIGHT}
      >
        <MPDButton name="more-info" onClick={onClick} />
      </Tooltip>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/more-info/more-info.tsx